export default {
  seeMoreAverageSellingPrice: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-average-selling-price',
    defaultMessage: 'See more average selling price',
  },
  seeMoreAverageSellingPriceContent: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-average-selling-price-content',
    defaultMessage:
      'It is the average device price in Good condition over the last 15 days on Back Market.',
  },
  seeMoreAverageSellingPriceContentItem1: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-average-selling-price-content-item-1',
    defaultMessage: 'Last 15 days',
  },
  seeMoreAverageSellingPriceContentItem1Value: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-average-selling-price-content-item-1-value',
    defaultMessage: 'For an up-to-date price',
  },
  seeMoreAverageSellingPriceContentItem2: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-average-selling-price-content-item-2',
    defaultMessage: 'Good condition',
  },
  seeMoreAverageSellingPriceContentItem2Value: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-average-selling-price-content-item-2-value',
    defaultMessage:
      'In the grade that you are most likely to sell back the device in Back Market',
  },
}
